var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"multi-language-button",on:{"click":_vm.clickChange}},[_vm._v(_vm._s(_vm.lang === 'ru' ? 'en': 'ru'))])}
var staticRenderFns = []

export { render, staticRenderFns }